<template>
    <!-- <AppLayout title="Admins"> -->
         
         <div class="d-flex flex-column pb-5">
            <v-card class="radius-0 radius-md-lg">
                <v-card-text class="d-flex flex-column ga-5">
                    <div>
                        <form @submit.prevent="convert">
                            <v-row class="grid-gap grid-gap-4">
                                
                                <v-col cols="6" sm="3">
                                    <div>
                                        <v-autocomplete-v1
                                            label="From"
                                            v-model="form.currency_from"
                                            :items="page.props.data.currencies ?? []"
                                            item-title="search"
                                            item-value="code"
                                            :error-messages="form.errors.currency_from"
                                            single-line
                                        >
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" :title="null">
                                                    <div class="fs-n1 text-no-wrap">{{item.raw.code}} ({{ item.raw.name }})</div>
                                                </v-list-item>
                                            </template>
                                            <template v-slot:chip="{ props, item }">
                                                <div class="fs-n1 text-no-wrap text-truncate">{{item.raw.code}} ({{ item.raw.name }})</div>
                                            </template>
                                        </v-autocomplete-v1>
                                    </div>
                                </v-col>
                                <v-col  cols="6" sm="3">
                                    <div>
                                        <v-autocomplete-v1
                                            label="To"
                                            v-model="form.currency_to"
                                            :items="page.props.data.currencies ?? []"
                                            item-title="search"
                                            item-value="code"
                                            :error-messages="form.errors.currency_to"
                                        >
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" :title="null">
                                                    <div class="fs-n1 text-no-wrap">{{item.raw.code}} ({{ item.raw.name }})</div>
                                                </v-list-item>
                                            </template>
                                            <template v-slot:chip="{ props, item }">
                                                <div class="fs-n1 text-no-wrap text-truncate">{{item.raw.code}} ({{ item.raw.name }})</div>
                                            </template>
                                        </v-autocomplete-v1>
                                    </div>
                                </v-col>
                                <v-col cols="auto" class="flex-grow-1">
                                    <div>
                                        <v-number-input-v1
                                            label="Amount"
                                            placeholder="0.00"
                                            :min="0"
                                            v-model="form.amount_from"
                                            :error-messages="form.errors.amount_from"
                                            class="control-hide-end"
                                        >
                                            <template #prepend-inner>
                                                <mdi-icon>payments</mdi-icon>
                                            </template>
                                        </v-number-input-v1>
                                    </div>
                                </v-col>
                                <v-col cols="auto">
                                    <div>
                                        <v-btn-v1 type="submit" :loading="form.processing" :disabled="form.processing">Convert</v-btn-v1>
                                    </div>
                                </v-col>
                            </v-row>
                        </form>
                    </div>
                    <div class="well pa-0" v-if="form.has_converted">
                        <div class="d-flex ga-3 pa-4 ps-md-4 pa-md-2 align-center flex-wrap">
                            <div class="flex-grow-1 d-flex gx-5 flex-wrap fs-3">
                                <div>
                                    <span class="text-secondary">Converted Amount:</span> <span class="fw-bold">{{ form.currency_to }} {{ helpers.moneyFormatNew(form.amount_to, 4, false) }}</span>
                                </div>
                                <div>
                                    <span class="text-secondary">Exchange Rate:</span> <span class="fw-bold">{{ helpers.moneyFormatNew(form.exchange_rate, 6, false) }}</span>
                                </div>
                            </div>
                            <div class="flex-none">
                                <v-btn color="warning" @click.prevent="() => { openFormStore() }">Store Log</v-btn>
                            </div>
                        </div>
                    </div>
                    <div v-if="form.errors.custom_error" class="text-error">{{ form.errors.custom_error }}</div>
                </v-card-text>
            </v-card>
         </div>
         <v-card class="d-flex flex-column flex-grow-1 table-card" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0">
                         <div class="w-100 w-sm-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                     </div>
                 </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                        <template v-slot:[`item.amount_from`]="{ item }:{item: FxTrade}" key="item.amount_from">
                            <div class="font-mono">
                                <span>{{ item.currency_from }}</span>  <span>{{ helpers.moneyFormatNew(item.amount_from, 2, false) }}</span>
                            </div>
                         </template>
                        <template v-slot:[`item.amount_to`]="{ item }:{item: FxTrade}" key="item.amount_to">
                            <div class="font-mono">
                                <span>{{ item.currency_to }}</span>  <span>{{ helpers.moneyFormatNew(item.amount_to, 2, false) }}</span>
                            </div>
                         </template>
                        <template v-slot:[`item.exchange_rate`]="{ item }:{item: FxTrade}" key="item.exchange_rate">
                            <div class="font-mono">
                                <span>{{ helpers.moneyFormatNew(item.exchange_rate, 6, false) }}</span>
                            </div>
                         </template>
                        <template v-slot:[`item.exchange_rate`]="{ item }:{item: FxTrade}" key="item.exchange_rate">
                            <div class="font-mono">
                                <span>{{ helpers.moneyFormatNew(item.exchange_rate, 6, false) }}</span>
                            </div>
                         </template>
                        <template v-slot:[`item.amount_traded`]="{ item }:{item: FxTrade}" key="item.amount_traded">
                            <div class="font-mono">
                                <span>{{ item.currency_to }}</span>  <span>{{ helpers.moneyFormatNew(item.amount_traded, 2, false) }}</span>
                            </div>
                            <div class="font-mono">
                                <small>
                                    Rate: <span>{{ helpers.moneyFormatNew(item.exchange_rate_traded, 6, false) }}</span>
                                </small>
                            </div>
                         </template>
                        <template v-slot:[`item.profit`]="{ item }:{item: FxTrade}" key="item.profit">
                            <div class="font-mono">
                                <span>{{ helpers.moneyFormatNew(item.profit_percent, 3, false) }}%</span>
                            </div>
                            <div class="font-mono">
                                <small>
                                    <span>{{ item.currency_to }}</span>  <span>{{ helpers.moneyFormatNew(item.profit, 2, false) }}</span>
                                </small>
                            </div>
                         </template>

                         <template v-slot:[`item.action`]="{ item }:{item: FxTrade}" key="item.action">
                            <div>
                                <div class="d-none d-md-block">
                                    <div class="d-flex justify-center">
                                        <v-tooltip text="Edit">
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="primary" v-bind="props" @click.prevent="() => { openFormStore(item) }">
                                                    <mdi-icon>edit_square</mdi-icon>
                                                </v-btn-icon-text>
                                            </template>
                                        </v-tooltip>
                                        
                                        <v-tooltip text="Edit">
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="danger" @click="deleteForm_Confirm(item)" v-bind="props">
                                                    <mdi-icon>delete</mdi-icon>
                                                </v-btn-icon-text>
                                            </template>
                                        </v-tooltip>
                                    </div>
                                </div>
                                <div class="d-md-none">
                                    <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain">
                                        <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>

                                        <v-menu activator="parent" class="tiny-dropdown">
                                            <v-list min-width="120px">
                                                <v-list-item title="Edit" value="edit_admin" @click.prevent="() => { openFormStore(item) }">
                                                    <template #prepend>
                                                        <mdi-icon>edit_square</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item title="Delete" color="danger" value="delete_admin" @click="deleteForm_Confirm(item)">
                                                        <template #prepend>
                                                            <mdi-icon>delete</mdi-icon>
                                                        </template>
                                                    </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-btn-icon>
                                </div>
                            </div>
                            
                        </template>
                     </DataTable>
                 </div>
             </v-card-text>
         </v-card>
         <v-dialog v-model="formStore.dialog" width="auto" @afterLeave="formStore.dialog = false" :persistent="formStore.processing">
            <v-card max-width="100%" width="500">
                <v-card-title>
                    <span v-if="formStore.id">Update Trage</span>
                    <span v-else>Store Trade</span>
                </v-card-title>
                <v-card-text class="py-4">
                    <div class="d-flex flex-column ga-4">
                        <div>
                            From: {{ formStore.currency_from }} {{ helpers.moneyFormatNew(formStore.amount_from, 4, false) }}
                        </div>
                        <div>
                            To: {{ formStore.currency_to }} {{ helpers.moneyFormatNew(formStore.amount_to, 4, false) }}
                        </div>
                        <div>
                            Exchange rate: {{ helpers.moneyFormatNew(formStore.exchange_rate, 6, false) }}
                        </div>
                        <div>
                            <v-text-field-v1
                                label="Date"
                                v-model="formStore.date"
                                placeholder=""
                                readonly
                                clearable
                                :error-messages="formStore.errors.date"
                            >
                                <template #prepend-inner>
                                    <mdi-icon>calendar_month</mdi-icon>
                                </template>
                                <v-menu activator="parent" v-model="paymentDateMenu" :close-on-content-click="false" min-width="0">
                                    <v-date-picker
                                        v-model="paymentDate"
                                        @update:model-value="paymentDateSelected"
                                        contained
                                    ></v-date-picker>
                                </v-menu>
                            </v-text-field-v1>
                        </div>
                        <div>
                            <v-number-input-v1
                                label="Traded Amount"
                                placeholder="0.00"
                                :min="0"
                                v-model="formStore.amount_traded"
                                :error-messages="formStore.errors.amount_traded"
                                class="control-hide-end"
                            >
                                <template #prepend-inner>
                                    <mdi-icon>payments</mdi-icon>
                                </template>
                                <template #append-inner>
                                    <span class="text-secondary pe-2">{{ formStore.currency_to }}</span>
                                </template>
                            </v-number-input-v1>
                            <div class="text-note pt-1 pb-2">This is the converted Amount you received</div>
                        </div>
                        <div>
                            <div>
                                <v-text-field-v1
                                    label="Description"
                                    v-model="formStore.description"
                                    placeholder=""
                                    :error-messages="formStore.errors.description"
                                >
                                    <template #prepend-inner>
                                        <mdi-icon>description</mdi-icon>
                                    </template>
                                </v-text-field-v1>
                            </div>
                        </div>
                        <div v-if="formStore.errors.custom_error" class="text-error">{{ formStore.errors.custom_error }}</div>
                    </div>
                    
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="Cancel"
                        color="btn-secondary"
                        :disabled="formStore.processing"
                        @click="formStore.dialog = false"
                    ></v-btn>
                    <v-btn
                        :disabled="formStore.processing"
                        :loading="formStore.processing"
                        @click="store"
                        text="Save"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteForm.show" width="auto" @afterLeave="deleteForm_Close">
            <v-card max-width="100%" width="500">
                <v-card-title>Delete Log</v-card-title>
                <v-card-subtitle>Are you sure you want to delete this Trage log?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div v-if="deleteForm.errors.custom_error" class="text-error">{{ deleteForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="Cancel"
                        color="btn-secondary"
                        @click="deleteForm_Close"
                    ></v-btn>
                    <v-btn
                        :disabled="deleteForm.processing"
                        :loading="deleteForm.processing"
                        @click="deleteForm_Submit"
                        color="error"
                        text="Delete"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
    <!-- </AppLayout> -->
</template>
<script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { useDatatable } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import { useAuth } from '@/Composables/Auth';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import helpers from '@/Plugins/helpers';
    import { FxTrade } from '@/Types/Models/fx-trade';
    import { useDate } from 'vuetify';
    import axios from '@/Plugins/axios';
    import { XhrError } from '@/Types/xhr-error';

    containerGapForTable();
    type PageData = SharedPageProps & {
        data:{
            table?: {
                datatable: any,
                columns: any
            };
            currencies:{
                code: string,
                name: string,
                search: string,

            }[],
        };
    }
    const ModuleName = 'Fx Trades';
    const { isSuperadmin } = useAuth();
    const page = usePage<PageData>();
    pageTitle.value = ModuleName;
    const datatable = useDatatable<FxTrade>(route('fx-trades.index'), page.props.data.table);


    const tableCard = useTableCard();

    const form = useForm<{
        custom_error: string,

        currency_from: string | null,
        currency_to: string | null,
        amount_from: number | null,
        amount_to: number | null,
        exchange_rate: number | null,
        has_converted: boolean,
    }>({
        custom_error: '',
        currency_from: null,
        currency_to: null,
        amount_from: null,
        amount_to: null,
        exchange_rate: null,
        has_converted: false,
    });
    
    const formStore = useForm<{
        dialog: boolean,
        custom_error: string,
        id: number,
        currency_from: string | null,
        currency_to: string | null,
        amount_from: number | null,
        amount_to: number | null,
        exchange_rate: number | null,
        date: string,
        description: string | null,
        amount_traded: number | null,
    }>({
        dialog: false,
        custom_error: '',
        id: 0,
        currency_from: null,
        currency_to: null,
        amount_from: null,
        amount_to: null,
        exchange_rate: null,
        date: '',
        description: null,
        amount_traded: null,
    });

    const date = useDate();
    const paymentDate = ref();
    const paymentDateMenu = ref(false);
    const paymentDateSelected = () => {
        paymentDateMenu.value = false;
        console.log(paymentDate.value)
        formStore.date = helpers.formatDate(paymentDate.value.toISOString())
    }

    const convert = () => {
        form.clearErrors();
        if(!form.currency_from){
            form.setError('currency_from', 'Required');
        }
        if(!form.currency_to){
            form.setError('currency_to', 'Required');
        }
        if((form.amount_from ?? 0) == 0){
            form.setError('amount_from', 'Required');
        }
        if(!form.hasErrors){
            form.processing = true;
            axios.post<{
                data:{
                    amount:{
                        from: number,
                        to: number,
                    },
                    currency:{
                        from: string,
                        to: string,
                    },
                    rate: number
                }
            }>(route('fx-trades.convert'), {
                currency_from: form.currency_from,
                currency_to: form.currency_to,
                amount_from: form.amount_from,
            }).then(({data}) => {
                let content = data.data;
                form.amount_to = content.amount.to;
                form.exchange_rate = content.rate;
                form.has_converted = true;
            })
            .catch((reason: XhrError) => {
                form.has_converted = false;
                form.amount_to = null;
                form.exchange_rate = null;
                form.setError('custom_error', reason.message);
            })
            .finally(() => {
                form.processing = false;
                
            });
        }
    }

    const openFormStore = (fxTrade: FxTrade | null = null) => {
        formStore.reset();
        formStore.clearErrors();
        if(fxTrade){
            formStore.id = fxTrade.id ?? 0;
            formStore.amount_from = helpers.parseFloat(fxTrade.amount_from);
            formStore.amount_to = helpers.parseFloat(fxTrade.amount_to);
            formStore.currency_from = fxTrade.currency_from ?? '';
            formStore.currency_to = fxTrade.currency_to ?? '';
            formStore.exchange_rate = helpers.parseFloat(fxTrade.exchange_rate);
            formStore.date = fxTrade.date ?? '';
            formStore.amount_traded = helpers.parseFloat(fxTrade.amount_traded);
            formStore.description = fxTrade.description ?? null;
        }
        else{
            if(form.has_converted){
                console.log(JSON.stringify(form.data()));
                formStore.id = 0;
                formStore.amount_from = form.amount_from;
                formStore.amount_to = form.amount_to;
                formStore.currency_from = form.currency_from;
                formStore.currency_to = form.currency_to;
                formStore.exchange_rate = form.exchange_rate;
            }
            else{
                form.setError('custom_error', 'You need to convert and amount before storing.');
            }
        }
        formStore.dialog = true;
    }
    
    const store = () => {
        formStore.clearErrors();
        if(!formStore.currency_from){
            formStore.setError('custom_error', 'Currency from Required');
        }
        if(!formStore.currency_to){
            formStore.setError('custom_error', 'Currency to Required');
        }
        if((formStore.amount_from ?? 0) == 0){
            formStore.setError('custom_error', 'Amount from Required');
        }
        if((formStore.amount_to ?? 0) == 0){
            formStore.setError('custom_error', 'Converted amount Required');
        }
        if((formStore.exchange_rate ?? 0) == 0){
            formStore.setError('custom_error', 'Exchange rate is Required');
        }
        if((formStore.amount_traded ?? 0) == 0){
            formStore.setError('amount_traded', 'Traded amount is Required');
        }
        if((!formStore.date.length)){
            formStore.setError('date', 'Date is Required');
        }
        if(!formStore.hasErrors){
            formStore.post(route('fx-trades.store', formStore.id ?? 0), {
                preserveScroll: true,
                onSuccess: ((page: Page<PageData>) => {
                    formStore.reset();
                    formStore.clearErrors();
                    toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Trading is saved successfully');
                    datatable.setTable(page.props.data.table);
                }) as GlobalEventCallback<"success">,
            });
        }
    }

    const deleteForm = useForm<{
        show: boolean,
        item: FxTrade | null,
        custom_error: string,
    }>({
        show: false,
        item: null,
        custom_error: '',
    });
    const deleteForm_Confirm = (item: FxTrade) => {
        deleteForm.reset();
        deleteForm.clearErrors();
        deleteForm.item = item;
        deleteForm.show = true;
    }
    const deleteForm_Close = () => {
        deleteForm.reset();
        deleteForm.clearErrors();
    }
    const deleteForm_Submit = () => {
        deleteForm.transform((data) => ({
            custom_error: data.custom_error
        })).delete(route('fs-trade.delete', deleteForm.item?.id), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                deleteForm_Close();
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Fingerprint is deleted');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    }
</script>